export default __webpack_public_path__ + "static/media/justine.93e3e6b7.png";